import React from "react";
import { createUseStyles } from "react-jss";
import { v4 } from "uuid";
import { PaddingTop } from "ComponentsUI/Spacings";
import Button from "ComponentsUI/Button";

const useStyles = createUseStyles((theme) => ({
	loadMoreButton: {
		display: "flex",
		justifyContent: "center",
	},
}));

const ShowMoreButton = (props) => {
	let { disabled, onClickHandler, windowSizes, text } = props;
	const classes = useStyles();

	let buttonFullWidth = false;

	if (windowSizes.xs) {
		buttonFullWidth = true;
	}
	return (
		<PaddingTop>
			<div className={classes.loadMoreButton}>
				<Button
					key={v4()}
					onClick={onClickHandler}
					status="purple"
					disabled={disabled}
					fullWidth={buttonFullWidth}
				>
					{text.TARIFF_SHOW_MORE}
				</Button>
			</div>
		</PaddingTop>
	);
};

export default ShowMoreButton;
